// extracted by mini-css-extract-plugin
export default {"occupancyContainer":"occupancy_section_occupancyContainer__N4g76","iconActive":"occupancy_section_iconActive__EE+gd","iconInactive":"occupancy_section_iconInactive__FKhWZ"};